// import React, { useState, useCallback, useMemo } from "react";
// import { Button } from "@shared/ui/button";
// import { Badge } from "@shared/ui/badge";
// import { Label } from "@shared/ui/label";
// import { Switch } from "@shared/ui/switch";
// import { 
//   Users, 
//   Plus, 
//   ChevronDown, 
//   ChevronUp, 
//   Trash, 
//   Pencil, 
//   BadgeCheck, 
//   X
// } from "lucide-react";
// import {
//   Collapsible,
//   CollapsibleContent,
//   CollapsibleTrigger,
// } from "@shared/ui/collapsible";
// import { FormField, FormService } from "@shared/services/FormServices";
// import { DynamicForm } from "@shared/components/DynamicForm";
// import {
//   deleteComplaintCategory,
//   deleteComplaintSubCategory,
//   updateComplaintCategory,
//   updateComplaintStatus,
//   useAllComplaintCategory,
//   useCreateComplaintCategory,
//   useCreateComplaintSubCategory,
//   useSearchAllComplaintCategory,
//   useUtilityServices,
// } from "@features/cx/settings/hooks";
// import { getComplaintSubCategory } from "@features/cx/settings/api";
// import { toast } from "@shared/hooks/use-toast";
// import { ComplaintCategoryType } from "@features/cx/settings/types";
// import { ServiceSubcategory } from "@features/cx/settings/types";
// import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
// import { logEvent } from "@shared/analytics/analytics";
// import { useDebounce } from "@shared/hooks/useDebounce";

// export interface ComplaintCategory {
//   name: string;
//   isActive: boolean;
//   createdBy: string;
//   description: string;
//   createdDate: string;
//   code: string;
//   childCount: number;
//   utilityService: string | string[];
// }

// export interface ComplaintSubcategory {
//   name: string;
//   isActive: boolean;
//   createdBy: string;
//   description: string;
//   createdDate: string;
//   code: string;
//   utilityService: string | string[];
// }

// interface ComplaintCategoryItemProps {
//   item: ComplaintCategory;
//   onEdit: () => void;
//   onDelete: () => void;
//   onToggleStatus: (newStatus: boolean) => void;
//   subCategories: ComplaintSubcategory[];
//   onAddSubCategory: (parentCode: string) => void;
//   onEditSubCategory: (subCategory: ComplaintSubcategory) => void;
//   onDeleteSubCategory: (subCategory: ComplaintSubcategory) => void;
//   onToggleSubCategoryStatus: (subCategory: ComplaintSubcategory, newStatus: boolean) => void;
//   isLoadingSubCategories: boolean;
//   onToggleExpand: (categoryCode: string, isOpen: boolean) => void;
//   isExpanded: boolean;
//   utilities: any[];
//   updatingStatusCode?: string;
// }

// const ComplaintCategoryItem: React.FC<ComplaintCategoryItemProps> = ({
//   item,
//   onEdit,
//   onDelete,
//   onToggleStatus,
//   subCategories = [],
//   onAddSubCategory,
//   onEditSubCategory,
//   onDeleteSubCategory,
//   onToggleSubCategoryStatus,
//   isLoadingSubCategories,
//   onToggleExpand,
//   isExpanded,
//   utilities,
//   updatingStatusCode,
// }) => {
//   const handleToggle = () => {
//     onToggleExpand(item.code, !isExpanded);
//   };

//   const renderUtilityServices = (utilityService: string | string[]) => {
//     if (!utilityService) return null;
    
//     const getUtilityName = (id: string) => {
//       const utility = utilities?.find((u) => u.id === id || u.name === id);
//       return utility ? utility.name : id;
//     };
    
//     const services = Array.isArray(utilityService)
//       ? utilityService.map(getUtilityName)
//       : [getUtilityName(utilityService)];
    
//     return (
//       <div className="flex flex-wrap gap-1 mt-1">
//         {services.map((service, index) => (
//           <Badge
//             key={`${service}-${index}`}
//             variant="secondary"
//             className="text-xs"
//           >
//             {service}
//           </Badge>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="rounded-md border mb-3 transition-colors overflow-hidden">
//       <div className="flex items-center justify-between p-3 hover:bg-muted/30">
//         <div className="flex-1">
//           <div className="flex items-center gap-2">
//             <h3 >{item.name}</h3>
//             {item.childCount > 0 && (
//               <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
//                 {item.childCount} sub-categories
//               </span>
//             )}
//           </div>
//           <p className="text-sm text-muted-foreground">{item.description}</p>
//           {renderUtilityServices(item.utilityService)}
//           <p className="text-xs text-muted-foreground">
//             Created by {item.createdBy} on {new Date(item.createdDate).toLocaleDateString()}
//           </p>
//         </div>
//         <div className="flex items-center space-x-2">
//           <div className="flex items-center gap-2">
//             <Label className="text-sm">
//               {item.isActive ? "Active" : "Inactive"}
//             </Label>
//             <Switch
//               checked={item.isActive}
//               disabled={updatingStatusCode === item.code}
//               onCheckedChange={(checked) => onToggleStatus(checked)}
//             />
//           </div>
//           <Button variant="ghost" size="sm" onClick={handleToggle}>
//             {isExpanded ? (
//               <ChevronUp className="h-4 w-4" />
//             ) : (
//               <ChevronDown className="h-4 w-4" />
//             )}
//           </Button>
//           <Button variant="ghost" size="sm" onClick={onEdit}>
//             Edit
//           </Button>
//           <Button 
//             variant="ghost" 
//             size="sm" 
//             onClick={onDelete}
//             className="text-destructive hover:text-destructive"
//           >
//             <Trash className="h-4 w-4" />
//           </Button>
//         </div>
//       </div>

//       <Collapsible open={isExpanded} onOpenChange={handleToggle}>
//         <CollapsibleContent>
//           <div className="bg-muted/20 p-3 border-t">
//             <div className="flex justify-between items-center mb-2">
//               <h4 className="text-sm font-medium">Sub-Categories</h4>
//               <Button
//                 variant="ghost"
//                 size="sm"
//                 className="h-7 text-xs"
//                 onClick={() => onAddSubCategory(item.code)}
//               >
//                 <Plus className="h-3 w-3 mr-1" /> Add
//               </Button>
//             </div>

//             {isLoadingSubCategories ? (
//               <div className="text-xs text-muted-foreground">Loading sub-categories...</div>
//             ) : subCategories.length > 0 ? (
//               <div className="space-y-1">
//                 {subCategories.map((sub) => (
//                   <div
//                     key={sub.code}
//                     className="flex justify-between items-center p-2 bg-background rounded text-sm"
//                   >
//                     <div className="flex-1">
//                       <div className="flex items-center gap-2">
//                         <span>{sub.name}</span>
//                       </div>
//                       {renderUtilityServices(sub.utilityService)}
//                     </div>
//                     <div className="flex items-center gap-2">
//                       <div className="flex items-center gap-2">
//                         <Label className="text-xs">
//                           {sub.isActive ? "Active" : "Inactive"}
//                         </Label>
//                         <Switch
//                           checked={sub.isActive}
//                           disabled={updatingStatusCode === sub.code}
//                           onCheckedChange={(checked) => onToggleSubCategoryStatus(sub, checked)}
//                         />
//                       </div>
//                       <Button
//                         variant="ghost"
//                         size="sm"
//                         className="h-6 w-6 p-0"
//                         onClick={() => onEditSubCategory(sub)}
//                       >
//                         <Pencil className="h-3 w-3 text-muted-foreground hover:text-primary" />
//                       </Button>
//                       <Button
//                         variant="ghost"
//                         size="sm"
//                         className="h-6 w-6 p-0"
//                         onClick={() => onDeleteSubCategory(sub)}
//                       >
//                         <Trash className="h-3 w-3 text-muted-foreground hover:text-destructive" />
//                       </Button>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <p className="text-xs text-muted-foreground">
//                 No sub-categories defined
//               </p>
//             )}
//           </div>
//         </CollapsibleContent>
//       </Collapsible>
//     </div>
//   );
// };

// export function ComplaintCategoriesTab() {
//   const remoteUtilityId = useRemoteUtilityId();
//   const [searchTerm, setSearchTerm] = useState("");
//   const debounced = useDebounce(searchTerm, 300);
//   const [isAddingCategory, setIsAddingCategory] = useState(false);
//   const [editingCategory, setEditingCategory] = useState<ComplaintCategory | null>(null);
//   const [isAddingSubCategory, setIsAddingSubCategory] = useState(false);
//   const [isEditingSubCategory, setIsEditingSubCategory] = useState(false);
//   const [editingSubCategory, setEditingSubCategory] = useState<ComplaintSubcategory | null>(null);
//   const [subCategoryParentCode, setSubCategoryParentCode] = useState<string | null>(null);
  
//   // Track which single category is expanded
//   const [expandedCategoryCode, setExpandedCategoryCode] = useState<string | null>(null);
//   const [categorySubcategories, setCategorySubcategories] = useState<Record<string, ComplaintSubcategory[]>>({});
//   const [loadingSubcategories, setLoadingSubcategories] = useState<Set<string>>(new Set());
//   const [updatingStatusCode, setUpdatingStatusCode] = useState<string | null>(null);

//   // API Hooks
//   const { data: categoriesData = [], refetch: refetchCategories } = useAllComplaintCategory();
//   const {data: searchedCategories } = useSearchAllComplaintCategory(debounced);
//   const { data: utilities } = useUtilityServices();
//   const createComplaintCategory = useCreateComplaintCategory();
//   const updateCategory = updateComplaintCategory();
//   const updateServiceStatus = updateComplaintStatus();
//   const deleteComplaintCategoryMutation = deleteComplaintCategory();
//   const deleteComplaintSubCategoryMutation = deleteComplaintSubCategory();
//   const createComplaintSubCategorymutation = useCreateComplaintSubCategory();


//   const categories = searchedCategories?.length ? searchedCategories : categoriesData;
//   // Utility Options for Forms
//   const getUtilityOptions = useMemo(() => {
//     if (!utilities || !Array.isArray(utilities)) {
//       return [];
//     }
//     return utilities
//       .filter((utility) => utility.isActive === true)
//       .map((utility) => ({
//         value: utility.name,
//         label: utility.name,
//       }));
//   }, [utilities]);

//   // Form fields for category
//   const categoryFormFields: FormField[] = [
//     {
//       name: "utility_service",
//       label: "Utility Services",
//       type: "multi-select",
//       required: false,
//       options: getUtilityOptions,
//       placeholder: "Select utility services...",
//       fullWidth: true,
//       searchable: true,
//       clearable: true,
//       disabled: !!editingCategory, // Disable when editing
//       maxDisplayItems: 3,
//       closeOnSelect: false,
//       classes: {
//         container: "w-full mb-4",
//         label: "block text-sm font-medium text-gray-700 mb-2",
//         select: `w-full border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${
//           !!editingCategory ? "opacity-50 cursor-not-allowed" : ""
//         }`,
//         error: "text-red-600 text-sm mt-1",
//       },
//     },
//     {
//       name: "name",
//       label: "Category Name",
//       type: "text",
//       required: true,
//       autoFocus: true,
//       maxLength: 100,
//       placeholder: "Enter category name",
//       fullWidth: true,
//       closeOnSelect: false,
//       maxDisplayItems: 0,
//       searchable: false,
//       clearable: false,
//       classes: {
//         container: "w-full mb-4",
//         label: "block text-sm font-medium text-gray-700 mb-2",
//         input:
//           "w-full h-10 px-3 border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors",
//         error: "text-red-600 text-sm mt-1",
//       },
//     },
//   ];

//   // Form fields for sub-category
//   const subCategoryFormFields: FormField[] = [
//     {
//       name: "utility_service",
//       label: "Utility Services",
//       type: "multi-select",
//       required: false,
//       options: getUtilityOptions,
//       placeholder: "Select utility services...",
//       fullWidth: true,
//       searchable: true,
//       clearable: true,
//       disabled: !!editingSubCategory, // Disable when editing
//       maxDisplayItems: 3,
//       closeOnSelect: false,
//       classes: {
//         container: "w-full mb-4",
//         label: "block text-sm font-medium text-gray-700 mb-2",
//         select: `w-full border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${
//           !!editingSubCategory ? "opacity-50 cursor-not-allowed" : ""
//         }`,
//         error: "text-red-600 text-sm mt-1",
//       },
//     },
//     {
//       name: "name",
//       label: "Subcategory Name",
//       type: "text",
//       required: true,
//       autoFocus: true,
//       maxLength: 100,
//       placeholder: "Enter subcategory name",
//       fullWidth: true,
//       classes: {
//         container: "w-full mb-3",
//         label: "block text-sm font-medium text-gray-700 mb-2",
//         input:
//           "w-full h-9 px-3 border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200",
//         error: "text-red-600 text-sm mt-1",
//       },
//       closeOnSelect: false,
//       maxDisplayItems: 0,
//       searchable: false,
//       clearable: false,
//     },
//   ];

//   // Create form instances
//   const categoryForm = FormService.createForm({
//     fields: categoryFormFields,
//     mode: "onChange",
//     validateOnMount: false,
//   });

//   const subCategoryForm = FormService.createForm({
//     fields: subCategoryFormFields,
//     mode: "onChange",
//     validateOnMount: false,
//   });

//   // Load subcategories for a specific category
//   const loadSubcategoriesForCategory = useCallback(
//     async (categoryCode: string) => {
//       if (!categoryCode || !remoteUtilityId) return;
      
//       try {
//         setLoadingSubcategories((prev) => new Set(prev).add(categoryCode));
//         const response = await getComplaintSubCategory(remoteUtilityId, categoryCode);
//         const subcategories = response || [];
//         setCategorySubcategories((prev) => ({
//           ...prev,
//           [categoryCode]: subcategories,
//         }));
//       } catch (err) {
//         console.error("Error loading subcategories:", err);
//         toast({
//           title: "Error",
//           description: "Failed to load subcategories",
//           variant: "destructive",
//         });
//       } finally {
//         setLoadingSubcategories((prev) => {
//           const newSet = new Set(prev);
//           newSet.delete(categoryCode);
//           return newSet;
//         });
//       }
//     },
//     [remoteUtilityId]
//   );

//   // Handle category submission
//   const handleCategorySubmit = async (data: { name: string; utility_service: string | string[] }) => {
//     try {
//       if (editingCategory) {
//         // When editing, only update the name
//         const payload = {
//           code: editingCategory.code,
//           name: data.name,
//           remote_utility_id: Number(remoteUtilityId),
//         };
//         await updateCategory.mutateAsync(payload);
//       } else {
//         // When creating, include utility services
//         const payload = {
//           name: data.name,
//           utility_service: data.utility_service || "",
//           remote_utility_id: Number(remoteUtilityId),
//           request_type: "complaint_type",
//           code: data.name,
//         };
//         await createComplaintCategory.mutateAsync(payload, {
//             onSuccess: () => {
//               logEvent('Complaint Category Added', {
//                 name: data.name,
//                 request_type: "complaint_type",
//                 code: data.name,
//               })
//             }, 
//             onError: (err) => {
//               logEvent('Error on Complaint Addition', {
//                 error: err.message,
//               })
//             }
//           });
//       }

//       categoryForm.reset();
//       setIsAddingCategory(false);
//       setEditingCategory(null);
//       refetchCategories();
//     } catch (error) {
//       console.error('Category operation failed:', error);
//       toast({
//         title: "Error",
//         description: "Failed to save category",
//         variant: "destructive",
//       });
//     }
//   };

//   // Handle subcategory submission
//   const handleSubCategorySubmit = async (data: { name: string; utility_service: string | string[] }) => {
//     try {
//       if (isEditingSubCategory && editingSubCategory) {
//         // When editing, only update the name
//         const payload = {
//           code: editingSubCategory.code,
//           name: data.name,
//           remote_utility_id: Number(remoteUtilityId),
//         };
//         await updateCategory.mutateAsync(payload);
//         setIsEditingSubCategory(false);
//         setEditingSubCategory(null);
//       } else if (subCategoryParentCode) {
//         // When creating, include utility services
//         const payload = {
//           name: data.name,
//           utility_service: data.utility_service || "",
//           remote_utility_id: Number(remoteUtilityId),
//           request_type: "service_sub_type",
//           code: `${subCategoryParentCode}_${data.name}`,
//         };
//         await createComplaintSubCategorymutation.mutateAsync(payload);
//       }

//       subCategoryForm.reset();
//       setIsAddingSubCategory(false);
//       setSubCategoryParentCode(null);
      
//       // Reload subcategories for the parent category
//       if (subCategoryParentCode) {
//         await loadSubcategoriesForCategory(subCategoryParentCode);
//       }
//     } catch (error) {
//       console.error('Sub-category operation failed:', error);
//       toast({
//         title: "Error",
//         description: "Failed to save sub-category",
//         variant: "destructive",
//       });
//     }
//   };

//   // Event handlers
//   const startAddCategory = () => {
//     categoryForm.reset();
//     setEditingCategory(null);
//     setIsAddingCategory(true);
//   };

//   const editCategory = (category: ComplaintCategory) => {
//     setEditingCategory(category);
//     categoryForm.setValue("name", category.name);
//     categoryForm.setValue("utility_service", category.utilityService || "");
//     setIsAddingCategory(true);
//   };

//   const deleteCategory = async (category: ComplaintCategory) => {
//     try {
//       await deleteComplaintCategoryMutation.mutateAsync(category);
//       refetchCategories();
//       toast({
//         title: "Success",
//         description: "Category deleted successfully",
//         variant: "default",
//       });
//     } catch (error) {
//       console.error("Failed to delete category:", error);
//       toast({
//         title: "Error",
//         description: "Failed to delete category",
//         variant: "destructive",
//       });
//     }
//   };

//   const startAddSubCategory = (parentCode: string) => {
//     setSubCategoryParentCode(parentCode);
//     setIsEditingSubCategory(false);
//     setEditingSubCategory(null);
//     setIsAddingSubCategory(true);
//     subCategoryForm.reset();
//   };

//   const editSubCategory = (subCategory: ComplaintSubcategory) => {
//     setIsEditingSubCategory(true);
//     setEditingSubCategory(subCategory);
    
//     // Find the parent category code
//     const parentCategoryCode = categories.find(cat => 
//       subCategory.code.startsWith(cat.code)
//     )?.code;
    
//     setSubCategoryParentCode(parentCategoryCode || null);
//     subCategoryForm.setValue("name", subCategory.name);
//     subCategoryForm.setValue("utility_service", subCategory.utilityService || "");
//     setIsAddingSubCategory(true);
//   };

//   const deleteSubCategory = async (subCategory: ComplaintSubcategory) => {
//     try {
//       await deleteComplaintSubCategoryMutation.mutateAsync(subCategory);
      
//       // Find the parent category and reload its subcategories
//       const parentCategoryCode = categories.find(cat => 
//         subCategory.code.startsWith(cat.code)
//       )?.code;
      
//       if (parentCategoryCode) {
//         await loadSubcategoriesForCategory(parentCategoryCode);
//       }
      
//       toast({
//         title: "Success",
//         description: "Sub-category deleted successfully",
//         variant: "default",
//       });
//     } catch (error) {
//       console.error("Failed to delete sub-category:", error);
//       toast({
//         title: "Error",
//         description: "Failed to delete sub-category",
//         variant: "destructive",
//       });
//     }
//   };

//   const cancelCategoryEdit = () => {
//     setIsAddingCategory(false);
//     setEditingCategory(null);
//     categoryForm.reset();
//   };

//   const cancelSubCategoryAdd = () => {
//     setIsAddingSubCategory(false);
//     setIsEditingSubCategory(false);
//     setEditingSubCategory(null);
//     setSubCategoryParentCode(null);
//     subCategoryForm.reset();
//   };

//   // Handle category expansion (only one at a time)
//   const handleCategoryToggle = (categoryCode: string, isOpen: boolean) => {
//     if (isOpen) {
//       setExpandedCategoryCode(categoryCode);
//       loadSubcategoriesForCategory(categoryCode);
//     } else {
//       setExpandedCategoryCode(null);
//     }
//   };

//   // Toggle Category Status (Active/Inactive)
//   const toggleCategoryStatus = async (categoryCode: string, newStatus: boolean) => {
//     try {
//       setUpdatingStatusCode(categoryCode);
//       const payload = {
//         code: categoryCode,
//         is_active: newStatus,
//         remote_utility_id: Number(remoteUtilityId),
//       };
//       await updateServiceStatus.mutateAsync(payload);
//       refetchCategories();
      
//       toast({
//         title: "Success",
//         description: `Category ${newStatus ? 'activated' : 'deactivated'} successfully`,
//         variant: "default",
//       });
//     } catch (error) {
//       console.error("Failed to update category status:", error);
//       toast({
//         title: "Error",
//         description: "Failed to update category status",
//         variant: "destructive",
//       });
//     } finally {
//       setUpdatingStatusCode(null);
//     }
//   };

//   // Toggle Subcategory Status (Active/Inactive)
//   const toggleSubcategoryStatus = async (subCategory: ComplaintSubcategory, newStatus: boolean) => {
//     try {
//       setUpdatingStatusCode(subCategory.code);
//       const payload = {
//         code: subCategory.code,
//         is_active: newStatus,
//         remote_utility_id: Number(remoteUtilityId),
//       };
//       await updateServiceStatus.mutateAsync(payload);
      
//       // Find the parent category and reload its subcategories
//       const parentCategoryCode = categories.find(cat => 
//         subCategory.code.startsWith(cat.code)
//       )?.code;
      
//       if (parentCategoryCode) {
//         await loadSubcategoriesForCategory(parentCategoryCode);
//       }
      
//       toast({
//         title: "Success",
//         description: `Sub-category ${newStatus ? 'activated' : 'deactivated'} successfully`,
//         variant: "default",
//       });
//     } catch (error) {
//       console.error("Failed to update sub-category status:", error);
//       toast({
//         title: "Error",
//         description: "Failed to update sub-category status",
//         variant: "destructive",
//       });
//     } finally {
//       setUpdatingStatusCode(null);
//     }
//   };

//   // Get sub-categories for a specific category
//   const getSubCategoriesForCategory = (categoryCode: string): ComplaintSubcategory[] => {
//     if (expandedCategoryCode === categoryCode) {
//       return categorySubcategories[categoryCode] || [];
//     }
//     return [];
//   };

//   // Check if loading subcategories for a specific category
//   const isLoadingSubCategoriesForCategory = (categoryCode: string): boolean => {
//     return expandedCategoryCode === categoryCode && loadingSubcategories.has(categoryCode);
//   };

//   if (!categories) {
//     return (
//       <div className="mb-8">
//         <div className="flex justify-between items-center mb-3">
//           <div className="flex items-center gap-2">
//             <h3 className="card-heading-text">Complaint Categories</h3>
//           </div>
//         </div>
//         <div className="text-center py-6">
//           <p className="text-sm text-muted-foreground">Loading categories...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="mb-8">
//       <div className="flex justify-between items-center mb-3">
//         <div className="flex items-center gap-2">
//           <h3 className="card-heading-text" >Complaint Categories</h3>
//         </div>
//         {!isAddingCategory && !isAddingSubCategory && (
//           <Button size="sm"  onClick={startAddCategory}>
//             <Plus className="h-4 w-4 mr-1" /> Add Category
//           </Button>
//         )}
//       </div>

//       {isAddingCategory ? (
//         <div className="border rounded-md p-4 mb-4">
//           <h3 className="font-medium mb-4">
//             {editingCategory ? "Edit Complaint Category" : "Add New Complaint Category"}
//           </h3>
//           <DynamicForm
//             fields={categoryFormFields}
//             form={categoryForm}
//             onSubmit={handleCategorySubmit}
//             onReset={cancelCategoryEdit}
//             loading={createComplaintCategory.isPending || updateCategory.isPending}
//             config={{
//               showProgress: false,
//               layout: "vertical",
//               submitButtonText: editingCategory ? "Update" : "Add",
//               showResetButton: true,
//               resetButtonText: "Cancel",
//               resetOnSubmit: false,
//               classes: {
//                 form: "space-y-4",
//                 fieldContainer: "",
//                 buttonContainer: "flex justify-end space-x-2 pt-4",
//                 fieldGroup: "",
//               },
//             }}
//             style={{
//               background: "transparent",
//               border: "none",
//               boxShadow: "none",
//             }}
//           />
//         </div>
//       ) : isAddingSubCategory ? (
//         <div className="border rounded-md p-4 mb-4">
//           <h3 className="font-medium mb-4">
//             {isEditingSubCategory ? "Edit Complaint Sub-Category" : "Add New Complaint Sub-Category"}
//           </h3>
//           <DynamicForm
//             fields={subCategoryFormFields}
//             form={subCategoryForm}
//             onSubmit={handleSubCategorySubmit}
//             onReset={cancelSubCategoryAdd}
//             loading={createComplaintSubCategorymutation.isPending || updateCategory.isPending}
//             config={{
//               showProgress: false,
//               layout: "vertical",
//               submitButtonText: isEditingSubCategory ? "Update" : "Add",
//               showResetButton: true,
//               resetButtonText: "Cancel",
//               resetOnSubmit: false,
//               classes: {
//                 form: "space-y-4",
//                 fieldContainer: "",
//                 buttonContainer: "flex justify-end space-x-2 pt-4",
//                 fieldGroup: "",
//               },
//             }}
//             style={{
//               background: "transparent",
//               border: "none",
//               boxShadow: "none",
//             }}
//           />
//         </div>
//       ) : categories.length > 0 ? (
//         <div>
//           <div>
//             <div className="relative w-1/2 mb-4">
//               <input
//                 type="text"
//                 value={searchTerm}
//                 placeholder="Search categories"
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="form-input w-full pr-10" // Added padding-right for icon space
//               />
  
//               {searchTerm && (
//                 <button
//                   type="button"
//                   onClick={() => setSearchTerm("")}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
//                 >
//                   <X size={18} />
//                 </button>
//               )}
//           </div>
//           </div>
//           {categories.map((category: any) => (
//             <ComplaintCategoryItem
//               key={category.code}
//               item={category}
//               onEdit={() => editCategory(category)}
//               onDelete={() => deleteCategory(category)}
//               onToggleStatus={(newStatus) => toggleCategoryStatus(category.code, newStatus)}
//               subCategories={getSubCategoriesForCategory(category.code)}
//               onAddSubCategory={startAddSubCategory}
//               onEditSubCategory={editSubCategory}
//               onDeleteSubCategory={deleteSubCategory}
//               onToggleSubCategoryStatus={toggleSubcategoryStatus}
//               isLoadingSubCategories={isLoadingSubCategoriesForCategory(category.code)}
//               onToggleExpand={handleCategoryToggle}
//               isExpanded={expandedCategoryCode === category.code}
//               utilities={utilities || []}
//               updatingStatusCode={updatingStatusCode}
//             />
//           ))}
//         </div>
//       ) : (
//         <div className="text-center py-6 border rounded-md bg-muted/30">
//           <BadgeCheck className="h-10 w-10 text-muted-foreground mx-auto mb-2" />
//           <h3 className="font-medium mb-1">No Complaint Categories</h3>
//           <p className="text-sm text-muted-foreground max-w-md mx-auto mb-4">
//             Create categories to organize complaints for better tracking and resolution.
//           </p>
//           <Button onClick={startAddCategory}>
//             <Plus className="h-4 w-4 mr-1" /> Add Your First Category
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useState, useCallback, useMemo } from "react";
import { Button } from "@shared/ui/button";
import { Badge } from "@shared/ui/badge";
import { Label } from "@shared/ui/label";
import { Switch } from "@shared/ui/switch";
import { 
  Users, 
  Plus, 
  ChevronDown, 
  ChevronUp, 
  Trash, 
  Pencil, 
  BadgeCheck, 
  X
} from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@shared/ui/collapsible";
import { FormField, FormService } from "@shared/services/FormServices";
import { DynamicForm } from "@shared/components/DynamicForm";
import {
  deleteComplaintCategory,
  deleteComplaintSubCategory,
  updateComplaintCategory,
  updateComplaintStatus,
  useAllComplaintCategory,
  useCreateComplaintCategory,
  useCreateComplaintSubCategory,
  useSearchAllComplaintCategory,
  useUtilityServices,
} from "@features/cx/settings/hooks";
import { getComplaintSubCategory } from "@features/cx/settings/api";
import { toast } from "@shared/hooks/use-toast";
import { ComplaintCategoryType } from "@features/cx/settings/types";
import { ServiceSubcategory } from "@features/cx/settings/types";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { logEvent } from "@shared/analytics/analytics";
import { useDebounce } from "@shared/hooks/useDebounce";

export interface ComplaintCategory {
  name: string;
  isActive: boolean;
  createdBy: string;
  description: string;
  createdDate: string;
  code: string;
  childCount: number;
  utilityService: string | string[];
}

export interface ComplaintSubcategory {
  name: string;
  isActive: boolean;
  createdBy: string;
  description: string;
  createdDate: string;
  code: string;
  utilityService: string | string[];
}

interface ComplaintCategoryItemProps {
  item: ComplaintCategory;
  onEdit: () => void;
  onDelete: () => void;
  onToggleStatus: (newStatus: boolean) => void;
  subCategories: ComplaintSubcategory[];
  onAddSubCategory: (parentCode: string) => void;
  onEditSubCategory: (subCategory: ComplaintSubcategory) => void;
  onDeleteSubCategory: (subCategory: ComplaintSubcategory) => void;
  onToggleSubCategoryStatus: (subCategory: ComplaintSubcategory, newStatus: boolean) => void;
  isLoadingSubCategories: boolean;
  onToggleExpand: (categoryCode: string, isOpen: boolean) => void;
  isExpanded: boolean;
  utilities: any[];
  updatingStatusCode?: string;
}

const ComplaintCategoryItem: React.FC<ComplaintCategoryItemProps> = ({
  item,
  onEdit,
  onDelete,
  onToggleStatus,
  subCategories = [],
  onAddSubCategory,
  onEditSubCategory,
  onDeleteSubCategory,
  onToggleSubCategoryStatus,
  isLoadingSubCategories,
  onToggleExpand,
  isExpanded,
  utilities,
  updatingStatusCode,
}) => {
  const handleToggle = () => {
    onToggleExpand(item.code, !isExpanded);
  };

  const renderUtilityServices = (utilityService: string | string[]) => {
    if (!utilityService) return null;
    
    const getUtilityName = (id: string) => {
      const utility = utilities?.find((u) => u.id === id || u.name === id);
      return utility ? utility.name : id;
    };
    
    const services = Array.isArray(utilityService)
      ? utilityService.map(getUtilityName)
      : [getUtilityName(utilityService)];
    
    return (
      <div className="flex flex-wrap gap-1 mt-1">
        {services.map((service, index) => (
          <Badge
            key={`${service}-${index}`}
            variant="secondary"
            className="text-xs"
          >
            {service}
          </Badge>
        ))}
      </div>
    );
  };

  return (
    <div className="rounded-md border mb-3 transition-colors overflow-hidden">
      <div className="flex items-center justify-between p-3 hover:bg-muted/30">
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3>{item.name}</h3>
            {item.childCount > 0 && (
              <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded">
                {item.childCount} sub-categories
              </span>
            )}
          </div>
          <p className="text-sm text-muted-foreground">{item.description}</p>
          {renderUtilityServices(item.utilityService)}
          <p className="text-xs text-muted-foreground">
            Created by {item.createdBy} on {new Date(item.createdDate).toLocaleDateString()}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <div className="flex items-center gap-2">
            <Label className="text-sm">
              {item.isActive ? "Active" : "Inactive"}
            </Label>
            <Switch
              checked={item.isActive}
              disabled={updatingStatusCode === item.code}
              onCheckedChange={(checked) => onToggleStatus(checked)}
            />
          </div>
          <Button variant="ghost" size="sm" onClick={handleToggle}>
            {isExpanded ? (
              <ChevronUp className="h-4 w-4" />
            ) : (
              <ChevronDown className="h-4 w-4" />
            )}
          </Button>
          <Button variant="ghost" size="sm" onClick={onEdit}>
            Edit
          </Button>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={onDelete}
            className="text-destructive hover:text-destructive"
          >
            <Trash className="h-4 w-4" />
          </Button>
        </div>
      </div>

      <Collapsible open={isExpanded} onOpenChange={handleToggle}>
        <CollapsibleContent>
          <div className="bg-muted/20 p-3 border-t">
            <div className="flex justify-between items-center mb-2">
              <h4 className="text-sm font-medium">Sub-Categories</h4>
              <Button
                variant="ghost"
                size="sm"
                className="h-7 text-xs"
                onClick={() => onAddSubCategory(item.code)}
              >
                <Plus className="h-3 w-3 mr-1" /> Add
              </Button>
            </div>

            {isLoadingSubCategories ? (
              <div className="text-xs text-muted-foreground">Loading sub-categories...</div>
            ) : subCategories.length > 0 ? (
              <div className="space-y-1">
                {subCategories.map((sub) => (
                  <div
                    key={sub.code}
                    className="flex justify-between items-center p-2 bg-background rounded text-sm"
                  >
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span>{sub.name}</span>
                      </div>
                      {renderUtilityServices(sub.utilityService)}
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="flex items-center gap-2">
                        <Label className="text-xs">
                          {sub.isActive ? "Active" : "Inactive"}
                        </Label>
                        <Switch
                          checked={sub.isActive}
                          disabled={updatingStatusCode === sub.code}
                          onCheckedChange={(checked) => onToggleSubCategoryStatus(sub, checked)}
                        />
                      </div>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-6 w-6 p-0"
                        onClick={() => onEditSubCategory(sub)}
                      >
                        <Pencil className="h-3 w-3 text-muted-foreground hover:text-primary" />
                      </Button>
                      <Button
                        variant="ghost"
                        size="sm"
                        className="h-6 w-6 p-0"
                        onClick={() => onDeleteSubCategory(sub)}
                      >
                        <Trash className="h-3 w-3 text-muted-foreground hover:text-destructive" />
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-xs text-muted-foreground">
                No sub-categories defined
              </p>
            )}
          </div>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

// Helper component to display available utilities info
const UtilityServiceInfo: React.FC<{ parentCode: string | null; categories: any[] }> = ({ 
  parentCode, 
  categories 
}) => {
  if (!parentCode) return null;
  
  const parentCategory = categories.find(cat => cat.code === parentCode);
  if (!parentCategory?.utilityService) return null;
  
  const parentUtilities = Array.isArray(parentCategory.utilityService) 
    ? parentCategory.utilityService 
    : [parentCategory.utilityService];
  
  return (
    <div className="mb-3 p-2 bg-blue-50 border border-blue-200 rounded text-xs">
      <span className="font-medium text-blue-800">Available utilities from parent category:</span>
      <div className="flex flex-wrap gap-1 mt-1">
        {parentUtilities.map((utility, index) => (
          <Badge key={index} variant="secondary" className="text-xs">
            {utility}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export function ComplaintCategoriesTab() {
  const remoteUtilityId = useRemoteUtilityId();
  const [searchTerm, setSearchTerm] = useState("");
  const debounced = useDebounce(searchTerm, 300);
  const [isAddingCategory, setIsAddingCategory] = useState(false);
  const [editingCategory, setEditingCategory] = useState<ComplaintCategory | null>(null);
  const [isAddingSubCategory, setIsAddingSubCategory] = useState(false);
  const [isEditingSubCategory, setIsEditingSubCategory] = useState(false);
  const [editingSubCategory, setEditingSubCategory] = useState<ComplaintSubcategory | null>(null);
  const [subCategoryParentCode, setSubCategoryParentCode] = useState<string | null>(null);
  
  // Track which single category is expanded
  const [expandedCategoryCode, setExpandedCategoryCode] = useState<string | null>(null);
  const [categorySubcategories, setCategorySubcategories] = useState<Record<string, ComplaintSubcategory[]>>({});
  const [loadingSubcategories, setLoadingSubcategories] = useState<Set<string>>(new Set());
  const [updatingStatusCode, setUpdatingStatusCode] = useState<string | null>(null);

  // API Hooks
  const { data: categoriesData = [], refetch: refetchCategories } = useAllComplaintCategory();
  const {data: searchedCategories } = useSearchAllComplaintCategory(debounced);
  const { data: utilities } = useUtilityServices();
  const createComplaintCategory = useCreateComplaintCategory();
  const updateCategory = updateComplaintCategory();
  const updateServiceStatus = updateComplaintStatus();
  const deleteComplaintCategoryMutation = deleteComplaintCategory();
  const deleteComplaintSubCategoryMutation = deleteComplaintSubCategory();
  const createComplaintSubCategorymutation = useCreateComplaintSubCategory();

  const categories = searchedCategories?.length ? searchedCategories : categoriesData;

  // Helper function to get filtered utility options
  const getFilteredUtilityOptions = useMemo(() => {
    // For categories - return all active utilities
    const getAllUtilities = () => {
      if (!utilities || !Array.isArray(utilities)) {
        return [];
      }
      return utilities
        .filter((utility) => utility.isActive === true)
        .map((utility) => ({
          value: utility.name,
          label: utility.name,
        }));
    };

    // For subcategories - return only utilities from parent category
    const getParentCategoryUtilities = (parentCode: string | null) => {
      if (!parentCode || !categories) {
        return [];
      }

      // Find the parent category
      const parentCategory = categories.find(cat => cat.code === parentCode);
      if (!parentCategory || !parentCategory.utilityService) {
        return [];
      }

      // Get utility services from parent category
      const parentUtilityServices = Array.isArray(parentCategory.utilityService) 
        ? parentCategory.utilityService 
        : [parentCategory.utilityService];

      // Filter and map to options format
      return parentUtilityServices.map(serviceName => ({
        value: serviceName,
        label: serviceName,
      }));
    };

    return {
      getAllUtilities,
      getParentCategoryUtilities,
    };
  }, [utilities, categories]);

  // Form fields for category
  const categoryFormFields: FormField[] = [
    {
      name: "utility_service",
      label: "Utility Services",
      type: "multi-select",
      required: true,
      options: getFilteredUtilityOptions.getAllUtilities(), // Use all utilities for categories
      placeholder: "Select utility services...",
      fullWidth: true,
      searchable: true,
      clearable: true,
      disabled: !!editingCategory, // Disable when editing
      maxDisplayItems: 3,
      closeOnSelect: false,
      classes: {
        container: "w-full mb-4",
        label: "block text-sm font-medium text-gray-700 mb-2",
        select: `w-full border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${
          !!editingCategory ? "opacity-50 cursor-not-allowed" : ""
        }`,
        error: "text-red-600 text-sm mt-1",
      },
    },
    {
      name: "name",
      label: "Category Name",
      type: "text",
      required: true,
      autoFocus: true,
      maxLength: 100,
      placeholder: "Enter category name",
      fullWidth: true,
      closeOnSelect: false,
      maxDisplayItems: 0,
      searchable: false,
      clearable: false,
      classes: {
        container: "w-full mb-4",
        label: "block text-sm font-medium text-gray-700 mb-2",
        input:
          "w-full h-10 px-3 border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors",
        error: "text-red-600 text-sm mt-1",
      },
    },
  ];

  // Form fields for sub-category - dynamically updated based on parent
  const subCategoryFormFields: FormField[] = [
    {
      name: "utility_service",
      label: "Utility Services",
      type: "multi-select",
      required: true,
      options: getFilteredUtilityOptions.getParentCategoryUtilities(subCategoryParentCode), // Use filtered utilities for subcategories
      placeholder: "Select utility services from parent category...",
      fullWidth: true,
      searchable: true,
      clearable: true,
      disabled: !!editingSubCategory, // Disable when editing
      maxDisplayItems: 3,
      closeOnSelect: false,
      classes: {
        container: "w-full mb-4",
        label: "block text-sm font-medium text-gray-700 mb-2",
        select: `w-full border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 ${
          !!editingSubCategory ? "opacity-50 cursor-not-allowed" : ""
        }`,
        error: "text-red-600 text-sm mt-1",
      },
    },
    {
      name: "name",
      label: "Subcategory Name",
      type: "text",
      required: true,
      autoFocus: true,
      maxLength: 100,
      placeholder: "Enter subcategory name",
      fullWidth: true,
      classes: {
        container: "w-full mb-3",
        label: "block text-sm font-medium text-gray-700 mb-2",
        input:
          "w-full h-9 px-3 border-2 border-blue-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200",
        error: "text-red-600 text-sm mt-1",
      },
      closeOnSelect: false,
      maxDisplayItems: 0,
      searchable: false,
      clearable: false,
    },
  ];

  // Create form instances
  const categoryForm = FormService.createForm({
    fields: categoryFormFields,
    mode: "onChange",
    validateOnMount: false,
  });

  const subCategoryForm = FormService.createForm({
    fields: subCategoryFormFields,
    mode: "onChange",
    validateOnMount: false,
  });

  // Load subcategories for a specific category
  const loadSubcategoriesForCategory = useCallback(
    async (categoryCode: string) => {
      if (!categoryCode || !remoteUtilityId) return;
      
      try {
        setLoadingSubcategories((prev) => new Set(prev).add(categoryCode));
        const response = await getComplaintSubCategory(remoteUtilityId, categoryCode);
        const subcategories = response || [];
        setCategorySubcategories((prev) => ({
          ...prev,
          [categoryCode]: subcategories,
        }));
      } catch (err) {
        console.error("Error loading subcategories:", err);
        toast({
          title: "Error",
          description: "Failed to load subcategories",
          variant: "destructive",
        });
      } finally {
        setLoadingSubcategories((prev) => {
          const newSet = new Set(prev);
          newSet.delete(categoryCode);
          return newSet;
        });
      }
    },
    [remoteUtilityId]
  );

  // Handle category submission
  const handleCategorySubmit = async (data: { name: string; utility_service: string | string[] }) => {
    try {
      if (editingCategory) {
        // When editing, only update the name
        const payload = {
          code: editingCategory.code,
          name: data.name,
          remote_utility_id: Number(remoteUtilityId),
        };
        await updateCategory.mutateAsync(payload);
      } else {
        // When creating, include utility services
        const payload = {
          name: data.name,
          utility_service: data.utility_service || "",
          remote_utility_id: Number(remoteUtilityId),
          request_type: "complaint_type",
          code: data.name,
        };
        await createComplaintCategory.mutateAsync(payload, {
            onSuccess: () => {
              logEvent('Complaint Category Added', {
                name: data.name,
                request_type: "complaint_type",
                code: data.name,
              })
            }, 
            onError: (err) => {
              logEvent('Error on Complaint Addition', {
                error: err.message,
              })
            }
          });
      }

      categoryForm.reset();
      setIsAddingCategory(false);
      setEditingCategory(null);
      refetchCategories();
    } catch (error) {
      console.error('Category operation failed:', error);
      toast({
        title: "Error",
        description: "Failed to save category",
        variant: "destructive",
      });
    }
  };

  // Handle subcategory submission
  const handleSubCategorySubmit = async (data: { name: string; utility_service: string | string[] }) => {
    try {
      if (isEditingSubCategory && editingSubCategory) {
        // When editing, only update the name
        const payload = {
          code: editingSubCategory.code,
          name: data.name,
          remote_utility_id: Number(remoteUtilityId),
        };
        await updateCategory.mutateAsync(payload);
        setIsEditingSubCategory(false);
        setEditingSubCategory(null);
      } else if (subCategoryParentCode) {
        // When creating, include utility services
        const payload = {
          name: data.name,
          utility_service: data.utility_service || "",
          remote_utility_id: Number(remoteUtilityId),
          request_type: "service_sub_type",
          code: `${subCategoryParentCode}_${data.name}`,
        };
        await createComplaintSubCategorymutation.mutateAsync(payload);
      }

      subCategoryForm.reset();
      setIsAddingSubCategory(false);
      setSubCategoryParentCode(null);
      
      // Reload subcategories for the parent category
      if (subCategoryParentCode) {
        await loadSubcategoriesForCategory(subCategoryParentCode);
      }
    } catch (error) {
      console.error('Sub-category operation failed:', error);
      toast({
        title: "Error",
        description: "Failed to save sub-category",
        variant: "destructive",
      });
    }
  };

  // Event handlers
  const startAddCategory = () => {
    categoryForm.reset();
    setEditingCategory(null);
    setIsAddingCategory(true);
  };

  const editCategory = (category: ComplaintCategory) => {
    setEditingCategory(category);
    categoryForm.setValue("name", category.name);
    categoryForm.setValue("utility_service", category.utilityService || "");
    setIsAddingCategory(true);
  };

  const deleteCategory = async (category: ComplaintCategory) => {
    try {
      await deleteComplaintCategoryMutation.mutateAsync(category);
      refetchCategories();
      toast({
        title: "Success",
        description: "Category deleted successfully",
        variant: "default",
      });
    } catch (error) {
      console.error("Failed to delete category:", error);
      toast({
        title: "Error",
        description: "Failed to delete category",
        variant: "destructive",
      });
    }
  };

 const startAddSubCategory = (parentCode: string) => {
  setSubCategoryParentCode(parentCode);
  setIsEditingSubCategory(false);
  setEditingSubCategory(null);
  setIsAddingSubCategory(true);
  subCategoryForm.reset();
};

  const editSubCategory = (subCategory: ComplaintSubcategory) => {
    console.log('Editing sub-category:', subCategory);  
    setIsEditingSubCategory(true);
    setEditingSubCategory(subCategory);
    
    // Find the parent category code
    const parentCategoryCode = categories.find(cat => 
      subCategory.code.startsWith(cat.code)
    )?.code;
    
    setSubCategoryParentCode(parentCategoryCode || null);
    
    // Set form values
    subCategoryForm.setValue("name", subCategory.name);
    subCategoryForm.setValue("utility_service", subCategory.utilityService || "");
    setIsAddingSubCategory(true);
  };

  const deleteSubCategory = async (subCategory: ComplaintSubcategory) => {
    try {
      await deleteComplaintSubCategoryMutation.mutateAsync(subCategory);
      
      // Find the parent category and reload its subcategories
      const parentCategoryCode = categories.find(cat => 
        subCategory.code.startsWith(cat.code)
      )?.code;
      
      if (parentCategoryCode) {
        await loadSubcategoriesForCategory(parentCategoryCode);
      }
      
      toast({
        title: "Success",
        description: "Sub-category deleted successfully",
        variant: "default",
      });
    } catch (error) {
      console.error("Failed to delete sub-category:", error);
      toast({
        title: "Error",
        description: "Failed to delete sub-category",
        variant: "destructive",
      });
    }
  };

  const cancelCategoryEdit = () => {
    setIsAddingCategory(false);
    setEditingCategory(null);
    categoryForm.reset();
  };

  const cancelSubCategoryAdd = () => {
    setIsAddingSubCategory(false);
    setIsEditingSubCategory(false);
    setEditingSubCategory(null);
    setSubCategoryParentCode(null);
    subCategoryForm.reset();
  };

  // Handle category expansion (only one at a time)
  const handleCategoryToggle = (categoryCode: string, isOpen: boolean) => {
    if (isOpen) {
      setExpandedCategoryCode(categoryCode);
      loadSubcategoriesForCategory(categoryCode);
    } else {
      setExpandedCategoryCode(null);
    }
  };

  // Toggle Category Status (Active/Inactive)
  const toggleCategoryStatus = async (categoryCode: string, newStatus: boolean) => {
    try {
      setUpdatingStatusCode(categoryCode);
      const payload = {
        code: categoryCode,
        is_active: newStatus,
        remote_utility_id: Number(remoteUtilityId),
      };
      await updateServiceStatus.mutateAsync(payload);
      refetchCategories();
      
      toast({
        title: "Success",
        description: `Category ${newStatus ? 'activated' : 'deactivated'} successfully`,
        variant: "default",
      });
    } catch (error) {
      console.error("Failed to update category status:", error);
      toast({
        title: "Error",
        description: "Failed to update category status",
        variant: "destructive",
      });
    } finally {
      setUpdatingStatusCode(null);
    }
  };

  // Toggle Subcategory Status (Active/Inactive)
  const toggleSubcategoryStatus = async (subCategory: ComplaintSubcategory, newStatus: boolean) => {
    try {
      setUpdatingStatusCode(subCategory.code);
      const payload = {
        code: subCategory.code,
        is_active: newStatus,
        remote_utility_id: Number(remoteUtilityId),
      };
      await updateServiceStatus.mutateAsync(payload);
      
      // Find the parent category and reload its subcategories
      const parentCategoryCode = categories.find(cat => 
        subCategory.code.startsWith(cat.code)
      )?.code;
      
      if (parentCategoryCode) {
        await loadSubcategoriesForCategory(parentCategoryCode);
      }
      
      toast({
        title: "Success",
        description: `Sub-category ${newStatus ? 'activated' : 'deactivated'} successfully`,
        variant: "default",
      });
    } catch (error) {
      console.error("Failed to update sub-category status:", error);
      toast({
        title: "Error",
        description: "Failed to update sub-category status",
        variant: "destructive",
      });
    } finally {
      setUpdatingStatusCode(null);
    }
  };

  // Get sub-categories for a specific category
  const getSubCategoriesForCategory = (categoryCode: string): ComplaintSubcategory[] => {
    if (expandedCategoryCode === categoryCode) {
      return categorySubcategories[categoryCode] || [];
    }
    return [];
  };

  // Check if loading subcategories for a specific category
  const isLoadingSubCategoriesForCategory = (categoryCode: string): boolean => {
    return expandedCategoryCode === categoryCode && loadingSubcategories.has(categoryCode);
  };

  if (!categories) {
    return (
      <div className="mb-8">
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-2">
            <h3 className="card-heading-text">Complaint Categories</h3>
          </div>
        </div>
        <div className="text-center py-6">
          <p className="text-sm text-muted-foreground">Loading categories...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-3">
        <div className="flex items-center gap-2">
          <h3 className="card-heading-text">Complaint Categories</h3>
        </div>
        {!isAddingCategory && !isAddingSubCategory && (
          <Button size="sm" onClick={startAddCategory}>
            <Plus className="h-4 w-4 mr-1" /> Add Category
          </Button>
        )}
      </div>

      {isAddingCategory ? (
        <div className="border rounded-md p-4 mb-4">
          <h3 className="font-medium mb-4">
            {editingCategory ? "Edit Complaint Category" : "Add New Complaint Category"}
          </h3>
          <DynamicForm
            fields={categoryFormFields}
            form={categoryForm}
            onSubmit={handleCategorySubmit}
            onReset={cancelCategoryEdit}
            loading={createComplaintCategory.isPending || updateCategory.isPending}
            config={{
              showProgress: false,
              layout: "vertical",
              submitButtonText: editingCategory ? "Update" : "Add",
              showResetButton: true,
              resetButtonText: "Cancel",
              resetOnSubmit: false,
              classes: {
                form: "space-y-4",
                fieldContainer: "",
                buttonContainer: "flex justify-end space-x-2 pt-4",
                fieldGroup: "",
              },
            }}
            style={{
              background: "transparent",
              border: "none",
              boxShadow: "none",
            }}
          />
        </div>
      ) : isAddingSubCategory ? (
        <div className="border rounded-md p-4 mb-4">
          <h3 className="font-medium mb-4">
            {isEditingSubCategory ? "Edit Complaint Sub-Category" : "Add New Complaint Sub-Category"}
          </h3>
          
          {/* Add utility service info */}
          <UtilityServiceInfo parentCode={subCategoryParentCode} categories={categories} />
          
          <DynamicForm
            fields={subCategoryFormFields}
            form={subCategoryForm}
            onSubmit={handleSubCategorySubmit}
            onReset={cancelSubCategoryAdd}
            loading={createComplaintSubCategorymutation.isPending || updateCategory.isPending}
            config={{
              showProgress: false,
              layout: "vertical",
              submitButtonText: isEditingSubCategory ? "Update" : "Add",
              showResetButton: true,
              resetButtonText: "Cancel",
              resetOnSubmit: false,
              classes: {
                form: "space-y-4",
                fieldContainer: "",
                buttonContainer: "flex justify-end space-x-2 pt-4",
                fieldGroup: "",
              },
            }}
            style={{
              background: "transparent",
              border: "none",
              boxShadow: "none",
            }}
          />
        </div>
      ) : categories.length > 0 ? (
        <div>
          <div>
            <div className="relative w-1/2 mb-4">
              <input
                type="text"
                value={searchTerm}
                placeholder="Search categories"
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-input w-full pr-10" // Added padding-right for icon space
              />
  
              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  <X size={18} />
                </button>
              )}
          </div>
          </div>
          {categories.map((category: any) => (
            <ComplaintCategoryItem
              key={category.code}
              item={category}
              onEdit={() => editCategory(category)}
              onDelete={() => deleteCategory(category)}
              onToggleStatus={(newStatus) => toggleCategoryStatus(category.code, newStatus)}
              subCategories={getSubCategoriesForCategory(category.code)}
              onAddSubCategory={startAddSubCategory}
              onEditSubCategory={editSubCategory}
              onDeleteSubCategory={deleteSubCategory}
              onToggleSubCategoryStatus={toggleSubcategoryStatus}
              isLoadingSubCategories={isLoadingSubCategoriesForCategory(category.code)}
              onToggleExpand={handleCategoryToggle}
              isExpanded={expandedCategoryCode === category.code}
              utilities={utilities || []}
              updatingStatusCode={updatingStatusCode}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-6 border rounded-md bg-muted/30">
          <BadgeCheck className="h-10 w-10 text-muted-foreground mx-auto mb-2" />
          <h3 className="font-medium mb-1">No Complaint Categories</h3>
          <p className="text-sm text-muted-foreground max-w-md mx-auto mb-4">
            Create categories to organize complaints for better tracking and resolution.
          </p>
          <Button onClick={startAddCategory}>
            <Plus className="h-4 w-4 mr-1" /> Add Your First Category
          </Button>
        </div>
      )}
    </div>
  );
}